import Vue from 'vue';
import App from './App.vue';
import store from './store';
import setupRouter from './router';

import './bootstrap';

import loadJSON from './utils';

Vue.config.productionTip = false;

Vue.prototype.$globalBus = new Vue();

const jsonPath = `${window.jsonPrefix}course.json?t=${window.publishDate}`;

loadJSON(jsonPath, (status, resp) => {
  if (status === null) {
    Vue.set(store.state, 'course', resp);

    // Setup color theme
    store.state.course.theme.forEach((c, index) => {
      document.body.style.setProperty(`--theme-color-${index + 1}`, c);
    });

    const token = localStorage.getItem('jwtToken');

    if (token && resp.mode !== 'hash') {
      window.http.post('/me', { token })
        .then((/* res */) => {
          // Setup member user
        })
        .catch(() => {
          console.log('DONT CHANGE LOCALSTORAGE');
        });
    }

    if (resp.mode === 'hash') {
      localStorage.setItem('jwtToken', 'embed');
    }

    new Vue({
      router: setupRouter(resp.mode === 'hash' ? 'hash' : 'history'),
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});
